import React from 'react';
import { Card } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

/*
 * Ringraziamento dopo l'invio di un ticket di assistenza dal Manager. Ci si arriva dalla pagina
 * del modulo (ticket/index.js) con la navigazione interna, senza ricaricare l'app.
 */
const TicketGraziePage = () => {
	const { pathname } = useLocation();
	const base = pathname.startsWith('/superadmin') ? '/superadmin' : '/struttura';

	return (
		<Card>
			<Card.Body className="sid-card-body--spaced">
				<h4 className="mb-3">Grazie, abbiamo ricevuto la tua richiesta</h4>
				<p className="mb-2">
					Il nostro team di assistenza l'ha già presa in carico e ti risponderà al più presto
					all'indirizzo email che hai indicato.
				</p>
				<p className="mb-4">
					Riceverai a breve un'email di conferma con il numero del ticket: per aggiungere dettagli o
					allegati basta rispondere a quell'email, senza cambiarne l'oggetto.
				</p>
				<div className="d-flex flex-wrap gap-2">
					<Link to={`${base}/ticket`} className="btn btn-primary">
						Apri un'altra richiesta
					</Link>
					<Link to={`${base}/dashboard`} className="btn btn-outline-secondary">
						Torna alla dashboard
					</Link>
				</div>
			</Card.Body>
		</Card>
	);
};

export default TicketGraziePage;
